import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseListsModal = _resolveComponent("BaseListsModal")!
  const _component_AddEditTreeGroupModal = _resolveComponent("AddEditTreeGroupModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseListsModal, {
      title: "Таможенные органы на границе",
      showModal: _ctx.showModal,
      leftConfig: _ctx.leftConfig,
      rightConfig: _ctx.rightConfig,
      leftValue: _ctx.selectedGroup,
      "onUpdate:leftValue": _ctx.onUpdateLeft,
      rightValue: _ctx.selectedItems,
      "onUpdate:rightValue": _ctx.onUpdateRight,
      disableActions: _ctx.isRootSelected,
      onAdd: _ctx.handleAdd,
      onEdit: _ctx.handleEdit,
      onDelete: _ctx.handleDelete,
      onSave: _ctx.handleSave,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, null, 8, ["showModal", "leftConfig", "rightConfig", "leftValue", "onUpdate:leftValue", "rightValue", "onUpdate:rightValue", "disableActions", "onAdd", "onEdit", "onDelete", "onSave"]),
    _createVNode(_component_AddEditTreeGroupModal, {
      show: _ctx.showAddEditModal,
      group: _ctx.editingGroup,
      groupsTree: _ctx.customsGroups,
      onSave: _ctx.handleSaveGroup,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddEditModal = false))
    }, null, 8, ["show", "group", "groupsTree", "onSave"])
  ], 64))
}